import { MijnRoute, MijnRouteKey } from './mijn-navigatie.model';
import { ACCOUNT } from './routes/account/account';
import { ACCOUNT_OVERVIEW } from './routes/account/overview';
import { ADDRESS_BOOK } from './routes/address-book';
import { AFLOSVRIJ_CHECK } from './routes/aflosvrij-check';
import { AFSPRAKENBEHEER } from './routes/afsprakenbeheer';
import { ASN_MIGRATION_ONBOARDING } from './routes/asn-migration-onboarding';
import { AUTO_TOP_UP } from './routes/auto-top-up/auto-top-up';
import { BALANCE_CHART } from './routes/balance-chart/balance-chart';
import { BUDGETS } from './routes/budgets/budgets';
import { BUDGET_CREATE } from './routes/budgets/budgets-create';
import { BUDGET_DETAILS } from './routes/budgets/budgets-details';
import { BUDGET_EDIT } from './routes/budgets/budgets-edit';
import { BUSINESS_CUSTOMER_BLOCKED } from './routes/business-customer-blocked';
import { CHANGE_DIGITAL_ADDRESS } from './routes/change-digital-address';
import { COLLECTION } from './routes/collection/collection';
import { COLLECTION_ADD_PERMISSION } from './routes/collection/collection-add-permission';
import { COLLECTION_CHANGE_PERMISSION_LIST } from './routes/collection/collection-change-permission-list';
import { COLLECTION_REFUND } from './routes/collection/collection-refund';
import { COLLECTION_REFUSE } from './routes/collection/collection-refuse';
import { COLLECTION_REMOVE_PERMISSION } from './routes/collection/collection-remove-permission';
import { COLLECTION_UPDATE_PERMISSION } from './routes/collection/collection-update-permission';
import { CONTACT } from './routes/contact';
import { CONTACT_TELEFONIE } from './routes/contact-telefonie';
import { DOCUMENT_OVERVIEW } from './routes/document-overview';
import { ERROR } from './routes/error';
import { EXTERNE_BETALING } from './routes/externe-betaling';
import { FIXED_EXPENSES } from './routes/fixed-expenses/fixed-expenses';
import { HUISMAP } from './routes/huismap';
import { HYPOTHEKEN_DOCUMENTEN_UPLOADEN } from './routes/hypotheken-documenten-uploaden';
import { INCASSO_BATCHES } from './routes/incasso-batches/incasso-batches';
import { INCASSO_BATCHES_DETAILS } from './routes/incasso-batches/incasso-batches-details';
import { INCASSO_BATCHES_ERROR } from './routes/incasso-batches/incasso-batches-error';
import { INCASSO_BATCHES_SIGN } from './routes/incasso-batches/incasso-batches-sign';
import { INCASSO_BATCHES_SUCCESS } from './routes/incasso-batches/incasso-batches-succes';
import { INCASSO_BATCHES_UITVALRAPPORTAGES } from './routes/incasso-batches/incasso-batches-uitvalrapportages';
import { INCASSO_BATCHES_UPLOAD } from './routes/incasso-batches/incasso-batches-upload';
import { INCOME_AND_EXPENSE_CATEGORY } from './routes/income-and-expense/category';
import { INCOME_AND_EXPENSE } from './routes/income-and-expense/income-and-expense';
import { INSURANCES_ADDPRODUCT } from './routes/insurance/insurance_addProducts';
import { INSURANCES_DETAILS } from './routes/insurance/insurance_details';
import { INSURANCES_MAINTENANCE } from './routes/insurance/insurance_maintenance';
import { INSURANCES_PRODUCTPAGE } from './routes/insurance/insurance_productPage';
import { INSURANCES } from './routes/insurance/insurances';
import { INVESTMENT_CANCEL_ACCOUNT } from './routes/investment/cancel-account';
import { INVESTMENT_CASH } from './routes/investment/cash';
import { INVESTMENT_COMPLETE } from './routes/investment/complete';
import { INVESTMENT_FINANCIAL_RETURN } from './routes/investment/financial_return';
import { INVESTMENT_MANAGE } from './routes/investment/manage';
import { INVESTMENT_ORDER } from './routes/investment/order';
import { INVESTMENT_ORDER_ALLOCATION } from './routes/investment/order-allocation';
import { INVESTMENT_ORDER_HISTORY } from './routes/investment/order_history';
import { INVESTMENT_ORDER_OVERVIEW } from './routes/investment/order_overview';
import { INVESTMENT_ORDERS } from './routes/investment/orders';
import { INVESTMENT_OVERVIEW } from './routes/investment/overview';
import { INVESTMENT_PLANNER } from './routes/investment/planner';
import { INVESTMENT_PLANNER_OVERVIEW } from './routes/investment/planner-overview';
import { INVESTMENT_PORTFOLIO } from './routes/investment/portfolio';
import { INVESTMENT_SIGN } from './routes/investment/sign';
import { INVESTMENT_SUSTAINABLE_RETURN } from './routes/investment/sustainable_return';
import { INVESTMENT_VIEW } from './routes/investment/view';
import { LOAN_APPLY } from './routes/loan-apply/loan-apply';
import { LOAN_APPLY_MANAGE } from './routes/loan-apply/loan-apply-manage';
import { MESSAGE_OVERVIEW } from './routes/message/message-overview';
import { MESSAGE_VIEW } from './routes/message/message-view';
import { MORTGAGE_ADDITIONAL_PAYMENT } from './routes/mortgage/additional-payment';
import { MORTGAGE_BUILD_FUND_DECLARE } from './routes/mortgage/build-fund-declare';
import { MORTGAGE_BUILD_FUND_NEW_ADDRESS } from './routes/mortgage/build-fund-new-address';
import { MORTGAGE_BUILD_FUND_TERMINATE } from './routes/mortgage/build-fund-terminate';
import { MORTGAGE_CHANGE_COLLECTION_ACCOUNT } from './routes/mortgage/change-collection-account';
import { MORTGAGE_CONVERT } from './routes/mortgage/convert';
import { MORTGAGE_DOCUMENTUPLOAD } from './routes/mortgage/document-upload';
import { MORTGAGE_HOUSE_VALUE } from './routes/mortgage/house-value';
import { MORTGAGE_INCREASE } from './routes/mortgage/increase';
import { MORTGAGE_INCREASE_KNOWLEDGE_TEST } from './routes/mortgage/increase-knowledge-test';
import { MORTGAGE_INCREASE_REQUEST } from './routes/mortgage/increase-request';
import { MORTGAGE_INTEREST_ADJUST } from './routes/mortgage/interest-adjust';
import { MORTGAGE_INTEREST_EXTEND } from './routes/mortgage/interest-extend';
import { MORTGAGE_INTEREST_ONLY_CHECK } from './routes/mortgage/interest-only-check';
import { MORTGAGE_NEXT_PAYMENT } from './routes/mortgage/next-payment';
import { MORTGAGE_OVERVIEW } from './routes/mortgage/overview';
import { MORTGAGE_OVERVIEW_DETAILS } from './routes/mortgage/overview-details';
import { MORTGAGE_PREVIOUS_PAYMENTS } from './routes/mortgage/previous-payments';
import { MORTGAGE_REDEEM } from './routes/mortgage/redeem';
import { OVERVIEW } from './routes/overview/overview';
import { OVERVIEW_ACCOUNTS } from './routes/overview/overview-accounts';
import { OVERVIEW_EDIT } from './routes/overview/overview-edit';
import { PAGE_NOT_FOUND } from './routes/page-not-found';
import { PAYMENT_BATCHES } from './routes/payment-batches/payment-batches';
import { PAYMENT_BATCHES_AFGEROND_BESTAND } from './routes/payment-batches/payment-batches-afgerond-bestand';
import { PAYMENT_BATCHES_BATCH_DETAILS } from './routes/payment-batches/payment-batches-batch-details';
import { PAYMENT_BATCHES_BATCH_BESTAND_DETAILS } from './routes/payment-batches/payment-batches-batchbestand-details';
import { PAYMENT_BATCHES_RESULT } from './routes/payment-batches/payment-batches-result';
import { PAYMENT_BATCHES_SIGN } from './routes/payment-batches/payment-batches-sign';
import { PAYMENT_BATCHES_UPLOAD } from './routes/payment-batches/payment-batches-upload';
import { PAYMENT_REQUEST } from './routes/payment-request/payment-request';
import { PAYMENT_REQUEST_FORM } from './routes/payment-request/payment-request-form';
import { MAKE_TRANSFER } from './routes/payment/make-transfer';
import { PAYMENTS_OVERVIEW } from './routes/payment/payments-overview';
import { PAYMENTS_PIGGYBANK_SUMMARY } from './routes/payment/piggybank-summary';
import { PAYMENTS_SIGN } from './routes/payment/sign';
import { PAYMENTS_SUMMARY } from './routes/payment/summary';
import { PENDING_PAYMENTS } from './routes/pending-payments/pending-payments';
import { PERSONAL_LOAN_OVERVIEW } from './routes/personal-loan/overview';
import { PERSONAL_LOAN_VIEW } from './routes/personal-loan/view';
import { PIGGY_BANKS } from './routes/piggy-banks';
import { PLANNED_PAYMENT } from './routes/planned-payments/planned-payment';
import { PLANNED_PAYMENT_VIEW } from './routes/planned-payments/planned-payment-view';
import { SELF_SERVICE_REFUSED_PAYMENTS } from './routes/refused-payments/refused-payments';
import { SELF_SERVICE_REFUSED_PAYMENTS_VIEW } from './routes/refused-payments/refused-payments-view';
import { PENSION_EXPANSION_REQUEST_DEPOSIT } from './routes/saving/pension-expansion-request-deposit';
import { PENSION_EXPANSION_REQUEST_INVESTMENT } from './routes/saving/pension-expansion-request-investment';
import { SELF_SERVICE_ACCOUNTBALANCES_DOWNLOAD } from './routes/self-service/accountbalances-download';
import { SELF_SERVICE_ACCOUNTS } from './routes/self-service/accounts';
import { SELF_SERVICE_ADD_PRODUCT } from './routes/self-service/add-product';
import { SELF_SERVICE_ALERTS_INCASSO } from './routes/self-service/alerts-incasso';
import { SELF_SERVICE_ALERTS_INTRODUCTION } from './routes/self-service/alerts-introduction';
import { SELF_SERVICE_ALERTS } from './routes/self-service/alerts-overview';
import { SELF_SERVICE_ALERTS_PENDING_PAYMENT } from './routes/self-service/alerts-pending-payment';
import { SELF_SERVICE_ALERTS_SALDO } from './routes/self-service/alerts-saldo';
import { SELF_SERVICE_ALERTS_SALDO_EDIT } from './routes/self-service/alerts-saldo-edit';
import { SELF_SERVICE_ALERTS_SECURITY } from './routes/self-service/alerts-security';
import { SELF_SERVICE_ALERTS_TRANSACTION } from './routes/self-service/alerts-transaction';
import { SELF_SERVICE_ALERTS_TRANSACTION_EDIT } from './routes/self-service/alerts-transaction-edit';
import { SELF_SERVICE_AUTH_TOKENS } from './routes/self-service/auth-tokens';
import { SELF_SERVICE_AUTH_TOKENS_REMOVE_DIGIPAS } from './routes/self-service/auth-tokens-remove-digipas';
import { SELF_SERVICE_CANCELLED_ACCOUNTS } from './routes/self-service/cancelled-accounts';
import { SELF_SERVICE_CHANGE_USERNAME_PASSWORD } from './routes/self-service/change-username-password';
import { SELF_SERVICE_CONTACT_DETAILS } from './routes/self-service/contact-details';
import { SELF_SERVICE_CURRENT_AFFAIRS } from './routes/self-service/current-affairs';
import { SELF_SERVICE_UNBLOCK_DIGIPAS } from './routes/self-service/digipas-unblock';
import { SELF_SERVICE_DYNAMIC_PROCESS } from './routes/self-service/dynamic-process';
import { SELF_SERVICE_ECOMMERCE } from './routes/self-service/ecommerce/ecommerce';
import { SELF_SERVICE_ECOMMERCE_PAYMENT } from './routes/self-service/ecommerce/payment';
import { SELF_SERVICE_ECOMMERCE_SUMMARY } from './routes/self-service/ecommerce/summary';
import { SELF_SERVICE_HERIDENTIFICATIE } from './routes/self-service/heridentificatie';
import { SELF_SERVICE_IDEAL } from './routes/self-service/ideal-selfservice';
import { SELF_SERVICE_IDEAL_DETAILS } from './routes/self-service/ideal-selfservice-details';
import { SELF_SERVICE_IDEAL_ERROR } from './routes/self-service/ideal-selfservice-error';
import { SELF_SERVICE_IDEAL_MAKE_PROFILE } from './routes/self-service/ideal-selfservice-make-profile';
import { SELF_SERVICE_IDIN } from './routes/self-service/idin';
import { SELF_SERVICE_MANAGE_ACCESS } from './routes/self-service/manage-access';
import { SELF_SERVICE_MESSAGE_PREFERENCES } from './routes/self-service/message-preferences';
import { SELF_SERVICE_MESSAGE_PREFERENCES_NBA } from './routes/self-service/message-preferences-nba';
import { SELF_SERVICE_MORTGAGES } from './routes/self-service/mortgages';
import { SELF_SERVICE_ONLINE_BANKING_CHILD } from './routes/self-service/online-banking-child';
import { SELF_SERVICE_PAYMENT_CARDS } from './routes/self-service/payment-cards';
import { SELF_SERVICE_ALERTS_PENDING_PAYMENT_EDIT } from './routes/self-service/pending-payment-edit';
import { SELF_SERVICE_PREFERREDACCOUNT } from './routes/self-service/preferred-account';
import { SELF_SERVICE_PRIVACY } from './routes/self-service/privacy';
import { AI_CONSENT } from './routes/self-service/privacy/ai-consent';
import { TELEPHONY_CONSENT } from './routes/self-service/privacy/telephony-consent';
import { SELF_SERVICE_PRODUCT_AANVRAGEN } from './routes/self-service/product-aanvragen';
import { SELF_SERVICE_PRODUCT_CATALOG } from './routes/self-service/product-catalog';
import { SELF_SERVICE_SAFETY_ACCESS } from './routes/self-service/safety-access';
import { SELF_SERVICE } from './routes/self-service/self-service';
import { SELF_SERVICE_SHARING_ACCESS } from './routes/self-service/sharing-access';
import { SELF_SERVICE_THIRD_PARTY_ACCESS } from './routes/self-service/third-party-access';
import { SELF_SERVICE_TOEGANGSNAAM_WACHTWOORD_AANVRAGEN } from './routes/self-service/toegangsnaam-wachtwoord-aanvragen';
import { SELF_SERVICE_TOKEN_LIMITS } from './routes/self-service/token-limits';
import { SELF_SERVICE_TOKENS_AUTHENTICATION_HISTORY } from './routes/self-service/tokens-authentication-history';
import { SELF_SERVICE_TRANSACTIONS_DOWNLOAD } from './routes/self-service/transactions-download';
import { SORRY } from './routes/sorry';
import { WIJZIGEN_AFSCHRIFTFREQUENTIE } from './routes/wijzigen-afschriftfrequentie';
import { ZAKELIJK_DIGIPAS_VERVANGEN } from './routes/zakelijk-digipas-vervangen';
import { ZAKELIJK_EXTRA_AFLOSSEN } from './routes/zakelijk-extra-aflossen';
import { MORTGAGE_OVERVIEW_ENERGYLABEL } from './routes/mortgage/overview-energylabel';

export const MijnRoutes = new Map<MijnRouteKey, MijnRoute>([
    [MijnRouteKey.AUTO_TOP_UP, AUTO_TOP_UP],
    [MijnRouteKey.ACCOUNT, ACCOUNT],
    [MijnRouteKey.ACCOUNT_OVERVIEW, ACCOUNT_OVERVIEW],
    [MijnRouteKey.AFLOSVRIJ_CHECK, AFLOSVRIJ_CHECK],
    [MijnRouteKey.AI_CONSENT, AI_CONSENT],
    [MijnRouteKey.AFSPRAKENBEHEER, AFSPRAKENBEHEER],
    [MijnRouteKey.ASN_MIGRATION_ONBOARDING, ASN_MIGRATION_ONBOARDING],
    [MijnRouteKey.BALANCE_CHART, BALANCE_CHART],
    [MijnRouteKey.BUDGETS, BUDGETS],
    [MijnRouteKey.BUDGET_CREATE, BUDGET_CREATE],
    [MijnRouteKey.BUDGET_DETAILS, BUDGET_DETAILS],
    [MijnRouteKey.BUDGET_EDIT, BUDGET_EDIT],
    [MijnRouteKey.BUSINESS_CUSTOMER_BLOCKED, BUSINESS_CUSTOMER_BLOCKED],
    [MijnRouteKey.ADDRESS_BOOK, ADDRESS_BOOK],
    [MijnRouteKey.CHANGE_DIGITAL_ADDRESS, CHANGE_DIGITAL_ADDRESS],
    [MijnRouteKey.COLLECTION, COLLECTION],
    [MijnRouteKey.COLLECTION_ADD_PERMISSION, COLLECTION_ADD_PERMISSION],
    [MijnRouteKey.COLLECTION_CHANGE_PERMISSION_LIST, COLLECTION_CHANGE_PERMISSION_LIST],
    [MijnRouteKey.COLLECTION_REFUND, COLLECTION_REFUND],
    [MijnRouteKey.COLLECTION_REFUSE, COLLECTION_REFUSE],
    [MijnRouteKey.COLLECTION_REMOVE_PERMISSION, COLLECTION_REMOVE_PERMISSION],
    [MijnRouteKey.COLLECTION_UPDATE_PERMISSION, COLLECTION_UPDATE_PERMISSION],
    [MijnRouteKey.CONTACT, CONTACT],
    [MijnRouteKey.CONTACT_TELEFONIE, CONTACT_TELEFONIE],
    [MijnRouteKey.ZAKELIJK_DIGIPAS_VERVANGEN, ZAKELIJK_DIGIPAS_VERVANGEN],
    [MijnRouteKey.DOCUMENT_OVERVIEW, DOCUMENT_OVERVIEW],
    [MijnRouteKey.ERROR, ERROR],
    [MijnRouteKey.FIXED_EXPENSES, FIXED_EXPENSES],
    [MijnRouteKey.HUISMAP, HUISMAP],
    [MijnRouteKey.HYPOTHEKEN_DOCUMENTEN_UPLOADEN, HYPOTHEKEN_DOCUMENTEN_UPLOADEN],
    [MijnRouteKey.EXTERNE_BETALING, EXTERNE_BETALING],
    [MijnRouteKey.INCASSO_BATCHES, INCASSO_BATCHES],
    [MijnRouteKey.INCASSO_BATCHES_DETAILS, INCASSO_BATCHES_DETAILS],
    [MijnRouteKey.INCASSO_BATCHES_ERROR, INCASSO_BATCHES_ERROR],
    [MijnRouteKey.INCASSO_BATCHES_SIGN, INCASSO_BATCHES_SIGN],
    [MijnRouteKey.INCASSO_BATCHES_UPLOAD, INCASSO_BATCHES_UPLOAD],
    [MijnRouteKey.INCASSO_BATCHES_SUCCESS, INCASSO_BATCHES_SUCCESS],
    [MijnRouteKey.INCASSO_BATCHES_UITVALRAPPORTAGES, INCASSO_BATCHES_UITVALRAPPORTAGES],
    [MijnRouteKey.INCOME_AND_EXPENSE, INCOME_AND_EXPENSE],
    [MijnRouteKey.INCOME_AND_EXPENSE_CATEGORY, INCOME_AND_EXPENSE_CATEGORY],
    [MijnRouteKey.INSURANCES, INSURANCES],
    [MijnRouteKey.INSURANCES_DETAILS, INSURANCES_DETAILS],
    [MijnRouteKey.INSURANCES_ADDPRODUCT, INSURANCES_ADDPRODUCT],
    [MijnRouteKey.INSURANCES_PRODUCTPAGE, INSURANCES_PRODUCTPAGE],
    [MijnRouteKey.INSURANCES_MAINTENANCE, INSURANCES_MAINTENANCE],
    [MijnRouteKey.INVESTMENT_MANAGE, INVESTMENT_MANAGE],
    [MijnRouteKey.INVESTMENT_ORDER, INVESTMENT_ORDER],
    [MijnRouteKey.INVESTMENT_ORDER_HISTORY, INVESTMENT_ORDER_HISTORY],
    [MijnRouteKey.INVESTMENT_ORDER_OVERVIEW, INVESTMENT_ORDER_OVERVIEW],
    [MijnRouteKey.INVESTMENT_OVERVIEW, INVESTMENT_OVERVIEW],
    [MijnRouteKey.INVESTMENT_FINANCIAL_RETURN, INVESTMENT_FINANCIAL_RETURN],
    [MijnRouteKey.INVESTMENT_ORDERS, INVESTMENT_ORDERS],
    [MijnRouteKey.INVESTMENT_SUSTAINABLE_RETURN, INVESTMENT_SUSTAINABLE_RETURN],
    [MijnRouteKey.INVESTMENT_PLANNER, INVESTMENT_PLANNER],
    [MijnRouteKey.INVESTMENT_PLANNER_OVERVIEW, INVESTMENT_PLANNER_OVERVIEW],
    [MijnRouteKey.INVESTMENT_ORDER_ALLOCATION, INVESTMENT_ORDER_ALLOCATION],
    [MijnRouteKey.INVESTMENT_SIGN, INVESTMENT_SIGN],
    [MijnRouteKey.INVESTMENT_COMPLETE, INVESTMENT_COMPLETE],
    [MijnRouteKey.INVESTMENT_CANCEL_ACCOUNT, INVESTMENT_CANCEL_ACCOUNT],
    [MijnRouteKey.INVESTMENT_PORTFOLIO, INVESTMENT_PORTFOLIO],
    [MijnRouteKey.INVESTMENT_CASH, INVESTMENT_CASH],
    [MijnRouteKey.INVESTMENT_VIEW, INVESTMENT_VIEW],
    [MijnRouteKey.LOAN_APPLY_MANAGE, LOAN_APPLY_MANAGE],
    [MijnRouteKey.LOAN_APPLY, LOAN_APPLY],
    [MijnRouteKey.MAKE_TRANSFER, MAKE_TRANSFER],
    [MijnRouteKey.MESSAGE_OVERVIEW, MESSAGE_OVERVIEW],
    [MijnRouteKey.MESSAGE_VIEW, MESSAGE_VIEW],
    [MijnRouteKey.MORTGAGE_ADDITIONAL_PAYMENT, MORTGAGE_ADDITIONAL_PAYMENT],
    [MijnRouteKey.MORTGAGE_BUILD_FUND_DECLARE, MORTGAGE_BUILD_FUND_DECLARE],
    [MijnRouteKey.MORTGAGE_BUILD_FUND_NEW_ADDRESS, MORTGAGE_BUILD_FUND_NEW_ADDRESS],
    [MijnRouteKey.MORTGAGE_BUILD_FUND_TERMINATE, MORTGAGE_BUILD_FUND_TERMINATE],
    [MijnRouteKey.MORTGAGE_CHANGE_COLLECTION_ACCOUNT, MORTGAGE_CHANGE_COLLECTION_ACCOUNT],
    [MijnRouteKey.MORTGAGE_CONVERT, MORTGAGE_CONVERT],
    [MijnRouteKey.MORTGAGE_DOCUMENTUPLOAD, MORTGAGE_DOCUMENTUPLOAD],
    [MijnRouteKey.MORTGAGE_HOUSE_VALUE, MORTGAGE_HOUSE_VALUE],
    [MijnRouteKey.MORTGAGE_INCREASE, MORTGAGE_INCREASE],
    [MijnRouteKey.MORTGAGE_INCREASE_KNOWLEDGE_TEST, MORTGAGE_INCREASE_KNOWLEDGE_TEST],
    [MijnRouteKey.MORTGAGE_INCREASE_REQUEST, MORTGAGE_INCREASE_REQUEST],
    [MijnRouteKey.MORTGAGE_INTEREST_ADJUST, MORTGAGE_INTEREST_ADJUST],
    [MijnRouteKey.MORTGAGE_INTEREST_EXTEND, MORTGAGE_INTEREST_EXTEND],
    [MijnRouteKey.MORTGAGE_INTEREST_ONLY_CHECK, MORTGAGE_INTEREST_ONLY_CHECK],
    [MijnRouteKey.MORTGAGE_NEXT_PAYMENT, MORTGAGE_NEXT_PAYMENT],
    [MijnRouteKey.MORTGAGE_OVERVIEW, MORTGAGE_OVERVIEW],
    [MijnRouteKey.MORTGAGE_OVERVIEW_DETAILS, MORTGAGE_OVERVIEW_DETAILS],
    [MijnRouteKey.MORTGAGE_OVERVIEW_ENERGYLABEL, MORTGAGE_OVERVIEW_ENERGYLABEL],
    [MijnRouteKey.MORTGAGE_PREVIOUS_PAYMENTS, MORTGAGE_PREVIOUS_PAYMENTS],
    [MijnRouteKey.MORTGAGE_REDEEM, MORTGAGE_REDEEM],
    [MijnRouteKey.OVERVIEW, OVERVIEW],
    [MijnRouteKey.OVERVIEW_ACCOUNTS, OVERVIEW_ACCOUNTS],
    [MijnRouteKey.OVERVIEW_EDIT, OVERVIEW_EDIT],
    [MijnRouteKey.PAGE_NOT_FOUND, PAGE_NOT_FOUND],
    [MijnRouteKey.PAYMENT_BATCHES, PAYMENT_BATCHES],
    [MijnRouteKey.PAYMENT_BATCHES_AFGEROND_BESTAND, PAYMENT_BATCHES_AFGEROND_BESTAND],
    [MijnRouteKey.PAYMENT_BATCHES_BATCH_DETAILS, PAYMENT_BATCHES_BATCH_DETAILS],
    [MijnRouteKey.PAYMENT_BATCHES_BATCH_BESTAND_DETAILS, PAYMENT_BATCHES_BATCH_BESTAND_DETAILS],
    [MijnRouteKey.PAYMENT_BATCHES_SIGN, PAYMENT_BATCHES_SIGN],
    [MijnRouteKey.PAYMENT_BATCHES_RESULT, PAYMENT_BATCHES_RESULT],
    [MijnRouteKey.PAYMENT_BATCHES_UPLOAD, PAYMENT_BATCHES_UPLOAD],
    [MijnRouteKey.PAYMENT_REQUEST_FORM, PAYMENT_REQUEST_FORM],
    [MijnRouteKey.PAYMENT_REQUEST, PAYMENT_REQUEST],
    [MijnRouteKey.PAYMENTS_OVERVIEW, PAYMENTS_OVERVIEW],
    [MijnRouteKey.PAYMENTS_SIGN, PAYMENTS_SIGN],
    [MijnRouteKey.PAYMENTS_SUMMARY, PAYMENTS_SUMMARY],
    [MijnRouteKey.PAYMENTS_PIGGYBANK_SUMMARY, PAYMENTS_PIGGYBANK_SUMMARY],
    [MijnRouteKey.PENDING_PAYMENTS, PENDING_PAYMENTS],
    [MijnRouteKey.PENSION_EXPANSION_REQUEST_INVESTMENT, PENSION_EXPANSION_REQUEST_INVESTMENT],
    [MijnRouteKey.PENSION_EXPANSION_REQUEST_DEPOSIT, PENSION_EXPANSION_REQUEST_DEPOSIT],
    [MijnRouteKey.PERSONAL_LOAN_OVERVIEW, PERSONAL_LOAN_OVERVIEW],
    [MijnRouteKey.PERSONAL_LOAN_VIEW, PERSONAL_LOAN_VIEW],
    [MijnRouteKey.PIGGY_BANKS, PIGGY_BANKS],
    [MijnRouteKey.PLANNED_PAYMENT_VIEW, PLANNED_PAYMENT_VIEW],
    [MijnRouteKey.PLANNED_PAYMENT, PLANNED_PAYMENT],
    [MijnRouteKey.SELF_SERVICE_ACCOUNTS, SELF_SERVICE_ACCOUNTS],
    [MijnRouteKey.SELF_SERVICE_ADD_PRODUCT, SELF_SERVICE_ADD_PRODUCT],
    [MijnRouteKey.SELF_SERVICE_ALERTS, SELF_SERVICE_ALERTS],
    [MijnRouteKey.SELF_SERVICE_ALERTS_INCASSO, SELF_SERVICE_ALERTS_INCASSO],
    [MijnRouteKey.SELF_SERVICE_ALERTS_INTRODUCTION, SELF_SERVICE_ALERTS_INTRODUCTION],
    [MijnRouteKey.SELF_SERVICE_ALERTS_PENDING_PAYMENT_EDIT, SELF_SERVICE_ALERTS_PENDING_PAYMENT_EDIT],
    [MijnRouteKey.SELF_SERVICE_ALERTS_PENDING_PAYMENT, SELF_SERVICE_ALERTS_PENDING_PAYMENT],
    [MijnRouteKey.SELF_SERVICE_ALERTS_SALDO_EDIT, SELF_SERVICE_ALERTS_SALDO_EDIT],
    [MijnRouteKey.SELF_SERVICE_ALERTS_SALDO, SELF_SERVICE_ALERTS_SALDO],
    [MijnRouteKey.SELF_SERVICE_ALERTS_SECURITY, SELF_SERVICE_ALERTS_SECURITY],
    [MijnRouteKey.SELF_SERVICE_ALERTS_TRANSACTION_EDIT, SELF_SERVICE_ALERTS_TRANSACTION_EDIT],
    [MijnRouteKey.SELF_SERVICE_ALERTS_TRANSACTION, SELF_SERVICE_ALERTS_TRANSACTION],
    [MijnRouteKey.SELF_SERVICE_AUTH_TOKENS_REMOVE_DIGIPAS, SELF_SERVICE_AUTH_TOKENS_REMOVE_DIGIPAS],
    [MijnRouteKey.SELF_SERVICE_AUTH_TOKENS, SELF_SERVICE_AUTH_TOKENS],
    [MijnRouteKey.SELF_SERVICE_CANCELLED_ACCOUNTS, SELF_SERVICE_CANCELLED_ACCOUNTS],
    [MijnRouteKey.SELF_SERVICE_CHANGE_USERNAME_PASSWORD, SELF_SERVICE_CHANGE_USERNAME_PASSWORD],
    [MijnRouteKey.SELF_SERVICE_CONTACT_DETAILS, SELF_SERVICE_CONTACT_DETAILS],
    [MijnRouteKey.SELF_SERVICE_CURRENT_AFFAIRS, SELF_SERVICE_CURRENT_AFFAIRS],
    [MijnRouteKey.SELF_SERVICE_ECOMMERCE, SELF_SERVICE_ECOMMERCE],
    [MijnRouteKey.SELF_SERVICE_ECOMMERCE_PAYMENT, SELF_SERVICE_ECOMMERCE_PAYMENT],
    [MijnRouteKey.SELF_SERVICE_ECOMMERCE_SUMMARY, SELF_SERVICE_ECOMMERCE_SUMMARY],
    [MijnRouteKey.SELF_SERVICE_HERIDENTIFICATIE, SELF_SERVICE_HERIDENTIFICATIE],
    [MijnRouteKey.SELF_SERVICE_IDEAL, SELF_SERVICE_IDEAL],
    [MijnRouteKey.SELF_SERVICE_IDEAL_DETAILS, SELF_SERVICE_IDEAL_DETAILS],
    [MijnRouteKey.SELF_SERVICE_IDEAL_ERROR, SELF_SERVICE_IDEAL_ERROR],
    [MijnRouteKey.SELF_SERVICE_IDEAL_MAKE_PROFILE, SELF_SERVICE_IDEAL_MAKE_PROFILE],
    [MijnRouteKey.SELF_SERVICE_IDIN, SELF_SERVICE_IDIN],
    [MijnRouteKey.SELF_SERVICE_MANAGE_ACCESS, SELF_SERVICE_MANAGE_ACCESS],
    [MijnRouteKey.SELF_SERVICE_MESSAGEPREFERENCES, SELF_SERVICE_MESSAGE_PREFERENCES],
    [MijnRouteKey.SELF_SERVICE_MESSAGE_PREFERENCES_NBA, SELF_SERVICE_MESSAGE_PREFERENCES_NBA],
    [MijnRouteKey.SELF_SERVICE_MORTGAGES, SELF_SERVICE_MORTGAGES],
    [MijnRouteKey.SELF_SERVICE_ONLINE_BANKING_CHILD, SELF_SERVICE_ONLINE_BANKING_CHILD],
    [MijnRouteKey.SELF_SERVICE_PAYMENT_CARDS, SELF_SERVICE_PAYMENT_CARDS],
    [MijnRouteKey.SELF_SERVICE_PREFERREDACCOUNT, SELF_SERVICE_PREFERREDACCOUNT],
    [MijnRouteKey.SELF_SERVICE_PRIVACY, SELF_SERVICE_PRIVACY],
    [MijnRouteKey.SELF_SERVICE_PRODUCT_AANVRAGEN, SELF_SERVICE_PRODUCT_AANVRAGEN],
    [MijnRouteKey.SELF_SERVICE_PRODUCT_CATALOG, SELF_SERVICE_PRODUCT_CATALOG],
    [MijnRouteKey.SELF_SERVICE_REFUSED_PAYMENTS, SELF_SERVICE_REFUSED_PAYMENTS],
    [MijnRouteKey.SELF_SERVICE_REFUSED_PAYMENTS_VIEW, SELF_SERVICE_REFUSED_PAYMENTS_VIEW],
    [MijnRouteKey.SELF_SERVICE_SAFETY_ACCESS, SELF_SERVICE_SAFETY_ACCESS],
    [MijnRouteKey.SELF_SERVICE_SHARING_ACCESS, SELF_SERVICE_SHARING_ACCESS],
    [MijnRouteKey.SELF_SERVICE_THIRD_PARTY_ACCESS, SELF_SERVICE_THIRD_PARTY_ACCESS],
    [MijnRouteKey.SELF_SERVICE_TOEGANGSNAAM_WACHTWOORD_AANVRAGEN, SELF_SERVICE_TOEGANGSNAAM_WACHTWOORD_AANVRAGEN],
    [MijnRouteKey.SELF_SERVICE_TOKEN_LIMITS, SELF_SERVICE_TOKEN_LIMITS],
    [MijnRouteKey.SELF_SERVICE_TOKENS_AUTHENTICATION_HISTORY, SELF_SERVICE_TOKENS_AUTHENTICATION_HISTORY],
    [MijnRouteKey.SELF_SERVICE_TRANSACTIONS_DOWNLOAD, SELF_SERVICE_TRANSACTIONS_DOWNLOAD],
    [MijnRouteKey.SELF_SERVICE_UNBLOCK_DIGIPAS, SELF_SERVICE_UNBLOCK_DIGIPAS],
    [MijnRouteKey.SELF_SERVICE_ACCOUNTBALANCES_DOWNLOAD, SELF_SERVICE_ACCOUNTBALANCES_DOWNLOAD],
    [MijnRouteKey.SELF_SERVICE, SELF_SERVICE],
    [MijnRouteKey.SELF_SERVICE_DYNAMIC_PROCESS, SELF_SERVICE_DYNAMIC_PROCESS],
    [MijnRouteKey.SORRY, SORRY],
    [MijnRouteKey.TELEPHONY_CONSENT, TELEPHONY_CONSENT],
    [MijnRouteKey.WIJZIGEN_AFSCHRIFTFREQUENTIE, WIJZIGEN_AFSCHRIFTFREQUENTIE],
    [MijnRouteKey.ZAKELIJK_EXTRA_AFLOSSEN, ZAKELIJK_EXTRA_AFLOSSEN]
]);
